import { yupResolver } from '@hookform/resolvers/yup';
import { joinInvitationTournamentValidationSchema } from './join-invitation-tournament-validation-schema';
import { useForm, UseFormReturn } from 'react-hook-form';

interface FormFields {
  isRewardBalanceSelected: boolean;
}
interface UseJoinTournamentTeamFormHook {
  form: UseFormReturn<FormFields>;
}

export const useJoinInvitationTournamentForm = (): UseJoinTournamentTeamFormHook => {
  const formResolver = yupResolver(joinInvitationTournamentValidationSchema());
  const form = useForm<FormFields>({
    mode: 'onChange',
    resolver: formResolver,
    defaultValues: { isRewardBalanceSelected: false },
  });

  return { form };
};
